module.exports = __webpack_public_path__ + "static/media/Processing.94fc2789.png";